import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import Dropzone from '@gef-ui/form-material/Dropzone';
import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { MaxLengths } from 'constants/forms';
import { FIELDS } from 'features/views/taskCreatingPages/form';

export const FileAttachments = () => {
	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('taskCreatingPages:fileAttachment')} />
				<Dropzone fieldName={FIELDS.fileUpload} append acceptAll numOfFiles={MaxLengths.FILE_AMOUNT} />
			</Stack>
		</Paper>
	);
};

export default FileAttachments;
